import Vue from 'vue'
import { setStorage, getStorage, clearStorage } from '@/utils'
import config from '@/config'

const eventBus = new Vue()
window['EventBus'] = eventBus

const vuePlugin = {
  install: function (Vue, options) {
    Vue.prototype.$eventBus = eventBus
    Vue.prototype.$setStorage = setStorage
    Vue.prototype.$getStorage = getStorage
    Vue.prototype.$clearStorage = clearStorage
    Vue.prototype.$config = config
  }
}
export default vuePlugin
